import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ExportWoDialogData {
  exists?: boolean;
  downloadUrl?: string;
  zipName?: string;
  async?: boolean;
  imageCount?: number;
  estimatedTime?: string;
  message?: string;
}

@Component({
  selector: 'app-export-wo-dialog',
  templateUrl: './export-wo-dialog.component.html',
  styleUrls: ['./export-wo-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExportWoDialogComponent {
  private dialogRef = inject(MatDialogRef<ExportWoDialogComponent>);
  data = inject<ExportWoDialogData>(MAT_DIALOG_DATA);

  get inProgress(): boolean {
    return !this.data.exists && this.data.async === true && !!this.data.message?.toLowerCase().includes('in progress');
  }

  onDownloadExisting(): void {
    if (this.data.downloadUrl) {
      window.open(this.data.downloadUrl, '_blank');
    }
    this.dialogRef.close();
  }

  onExportAgain(): void {
    this.dialogRef.close({ force: true });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
